import { Badge } from '@playerbase/ui';
import type { PlaytestSessionState } from '@playerbase/types';

const STATE_LABEL: Record<PlaytestSessionState, string> = {
  in_progress: 'In progress',
  completed: 'Completed',
  expired: 'Expired',
  abandoned: 'Abandoned',
};

const STATE_TONE: Record<PlaytestSessionState, 'info' | 'success' | 'warning' | 'neutral'> = {
  in_progress: 'info',
  completed: 'success',
  expired: 'warning',
  abandoned: 'neutral',
};

export function SessionStateBadge({ state }: { state: PlaytestSessionState }): JSX.Element {
  return (
    <Badge tone={STATE_TONE[state]} aria-label={`State: ${STATE_LABEL[state]}`}>
      {STATE_LABEL[state]}
    </Badge>
  );
}
